import { paywallCheckoutApi } from "@circle-react/api/paywallCheckoutApi";
import type {
  ShowEndpointQueryParams,
  ShowResponseEndpoint,
} from "@circle-react/api/paywallCheckoutApi.types";
import type { PaywallHandlerError } from "@circle-react/contexts/Paywalls/usePaywallCheckout";
import { useMutation } from "react-query";

import type {
  CheckoutPreviewContext,
  PaywallCheckout,
} from "../../types/CheckoutProps";
import { fetchMockedData } from "./fetchMockedData";

interface UseCouponPreviewMutationProps {
  checkoutPreviewContext?: CheckoutPreviewContext;
  paywall?: PaywallCheckout;
}

export type PaywallPreviewCouponApplication = Pick<
  ShowResponseEndpoint,
  "paywall" | "paywall_coupon"
>;

export const useCouponPreviewMutation = ({
  checkoutPreviewContext,
  paywall,
}: UseCouponPreviewMutationProps) => {
  const mutator =
    paywall && checkoutPreviewContext
      ? fetchMockedData(paywall, checkoutPreviewContext)
      : paywallCheckoutApi.show;

  return useMutation<
    PaywallPreviewCouponApplication,
    PaywallHandlerError,
    ShowEndpointQueryParams
  >({
    mutationFn: mutator,
  });
};
